import React from 'react';
// import { AES, enc } from 'crypto-js';

import { showNotification } from '../store/notification/notification.action';
import {
  ClientStorageKey,
  NOTIFICATION_TYPES,
  TENANT,
  TENANT_NAME,
  TenantKey,
} from '../constant/constant';
import moment from 'moment-timezone';
import storage from './storage/storage';
import FTGLogo from '../assets/images/flextg-logo.png';
import FlotechLogo from '../assets/images/flotech-logo.png';
import MarimonLogo from '../assets/images/marimon-logo.png';
import { getColorConfig } from '../constant/supply-colors';

let store: any = null;

// export const encrypt = (plainText: string) => {
//   return AES.encrypt(plainText, SECRET_PASSWORD).toString();
// };
//
// export const decrypt = (cipherText: string) => {
//   const bytes = AES.decrypt(cipherText, SECRET_PASSWORD);
//   return bytes.toString(enc.Utf8);
// };

export const setUtilStore = (storeArg: string) => {
  store = storeArg;
};
export const APPLICATION_CONTEXT: any = React.createContext(null);

export interface ClientApplicationContextType {
  isClientApp?: boolean;
  setCustomerInfo?: any;
  customerInfo?: object | null;
  tokens?: any;
  setTokens?: any;
  redirectUrl?: string;
  setRedirectUrl?: string;
  bannerMessage?: string;
  maintenanceMessage?: string;
}

export const tenantLogo = (tenantName) => {
  if (tenantName === TENANT.FLEXPRINT || tenantName === TENANT.SANDBOX) {
    return FTGLogo;
  }
  if (tenantName === TENANT.FLOTECH) {
    return FlotechLogo;
  }
  if (tenantName === TENANT.MARIMON) {
    return MarimonLogo;
  }
  return '';
};

export const doHavePermisions = ({
  tokens,
  permissions,
  url = '/admin/pageNotFound',
}: any) => {
  let valid = true;
  permissions.map((permission: any) => {
    if (tokens && tokens.indexOf(permission) === -1) {
      valid = false;
    }
  });
  if (!valid) {
    window.location.href = url;
    return false;
  }
  return true;
};

export const displayTenantNameName = (tenantName: string) => {
  return TENANT_NAME[tenantName] || '';
};

export const isMobile = () => {
  let userAgent = navigator.userAgent;
  let isMobileDevice =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );
  return isMobileDevice;
};

export const isIpad = () => {
  let userAgent = navigator.userAgent;
  let isIpadDevice = /iPad/i.test(userAgent);
  return isIpadDevice;
};
// Check if the user is on an iPad

export function generateRandomString(length: number) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }

  return result.trim();
}

export interface ShowErrorMessageType {
  type: string | null;
  message: string;
}
export const showMessage = ({ type = null, message }: ShowErrorMessageType) => {
  if (store && store.dispatch) {
    store.dispatch(showNotification({ type, message }));
  }
};
export const message = {
  error: (msg: string, props = {}) =>
    showMessage({
      type: NOTIFICATION_TYPES.ERROR,
      message: msg,
      ...{ ...props, duration: 10000 },
    }),
  success: (msg: string, props = {}) =>
    showMessage({
      type: NOTIFICATION_TYPES.SUCCESS,
      message: msg,
      ...props,
    }),
  warn: (msg: string, props = {}) =>
    showMessage({
      type: NOTIFICATION_TYPES.WARNING,
      message: msg,
      ...props,
    }),
  info: (msg: string, props = {}) =>
    showMessage({ type: NOTIFICATION_TYPES.INFO, message: msg, ...props }),
};
export const formattingTimeIntoMMDDYY = (date: any) => {
  return moment(date).format('MM-DD-YYYY');
};

export const getTime = (date: string) => {
  try {
    return moment(date)
      .tz(moment.tz.guess())
      .format(`YYYY-MM-DD hh:mm A \\[z\\] `)
      .toString();
  } catch (e) {
    return '';
  }
};
export const RemoveLocalStorageKeys = (StorageObj: any, except: any = null) => {
  const adminKey: any = Object.values(StorageObj);
  adminKey.map((val: string) => {
    if (except && except.length) {
      const isExist = except.includes(val);
      if (!isExist) {
        storage.removeItem(val);
      }
    } else {
      storage.removeItem(val);
    }
  });
};

// Mapping from Category codes to supply color keys
const CATEGORY_TO_COLOR_KEY: Record<string, string> = {
  'S-I-MK': 'matteblack',      // Matte Black
  'S-I-PK': 'photoblack',       // Photo Black
  'S-I-C': 'cyan',              // Cyan (already covered)
  'S-I-PC': 'photocyan',        // Photo Cyan
  'S-I-M': 'magenta',           // Magenta (already covered)
  'S-I-PM': 'photomagenta',     // Photo Magenta
  'S-I-Y': 'yellow',            // Yellow (already covered)
  'S-I-B': 'blue',              // Blue
  'S-I-R': 'red',               // Red
  'S-I-GR': 'gray',             // Gray
  'S-I-PG': 'photogray',        // Photo Gray
  'S-I-CO': 'chromaoptimizer',  // Chroma Optimizer
  'S-W': 'maintenance',         // Maintenance/Waste Toner
};

/**
 * Returns the color value (barColor) for a product based on Category or description
 * @param description - Product description (ItemDescription or CatDescription)
 * @param category - Optional Category code (e.g., "S-I-C", "S-I-MK")
 * @returns Color value (hex or gradient string) from supply-colors.ts, or null if no match
 */
export const colorCoder = (description: string, category?: string): string | null => {
  // First, try Category-based mapping (most reliable)
  if (category && CATEGORY_TO_COLOR_KEY[category]) {
    const colorKey = CATEGORY_TO_COLOR_KEY[category];
    const colorConfig = getColorConfig(colorKey);
    return colorConfig?.barColor || null;
  }

  // Fall back to existing description-based matching (backward compatibility)
  let cleanDescription = description.toString().toLowerCase();
  const tenant = storage.getItem(TenantKey);
  let colorKey: string | null = null;

  if (tenant === TENANT.MARIMON) {
    if (cleanDescription.match('cyan')) {
      colorKey = 'cyan';
    } else if (cleanDescription.match('black')) {
      colorKey = 'black';
    } else if (cleanDescription.match('magenta')) {
      colorKey = 'magenta';
    } else if (cleanDescription.match('yellow')) {
      colorKey = 'yellow';
    }
  } else {
    if (cleanDescription.match('toner cyan')) {
      colorKey = 'cyan';
    } else if (cleanDescription.match('toner black')) {
      colorKey = 'black';
    } else if (cleanDescription.match('toner magenta')) {
      colorKey = 'magenta';
    } else if (cleanDescription.match('toner yellow')) {
      colorKey = 'yellow';
    }
    if (cleanDescription.match('ink cyan')) {
      colorKey = 'cyan';
    } else if (cleanDescription.match('ink black')) {
      colorKey = 'black';
    } else if (cleanDescription.match('ink magenta')) {
      colorKey = 'magenta';
    } else if (cleanDescription.match('ink yellow')) {
      colorKey = 'yellow';
    }
  }

  // Convert color key to actual color value from supply-colors.ts
  if (colorKey) {
    const colorConfig = getColorConfig(colorKey);
    return colorConfig?.barColor || null;
  }

  return null;
};
export const isCheckDollerProcingNonZero = (value: any) => {
  const appHideZeroDollarPricing = value && parseFloat(value) === 0.0 || !value;
  const customerInfo: any = storage.getJSONItem(ClientStorageKey.customerInfo);
  return !(
    customerInfo &&
    customerInfo?.HideZeroDollarPricing &&
    appHideZeroDollarPricing
  );
};

// trim all the strings in an object recursively
 export const trimStringsFromObjects = (obj: any) => {
  const newObj = obj;

  Object.keys(newObj).forEach((key) => {
    if (typeof newObj[key] === 'string' && newObj[key] !== null){
      newObj[key] = newObj[key].trim();
    }
    if (typeof newObj[key] === 'object' && newObj[key] !== null) {
      newObj[key] = trimStringsFromObjects(newObj[key]);
    }
  });

  return newObj;
}

export function getLocalTimezone() {
  const localTimezone = moment.tz.guess();
  return localTimezone
}

export const renderUSCurrency = (value: number | string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(+value);
}

